import { BehaviorSubject } from 'rxjs'
export default new BehaviorSubject<number>(0)
